<template>
    <div v-loading.fullscreen.lock="loading">
        <over-time-search-bar-component
            add_auth="新增加班申请"
            @search="get_over_time_index"
            @addTeam="addTeam"
            @out_excel="outExcel"
        ></over-time-search-bar-component>
        <common-table-component
            details_auth="加班申请详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_over_time"
            table_height="549px"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_over_time_index"
        ></common-page-component>
        <over-time-edit-component            
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :over_time_details_data="over_time_details_data"
            :edit_auth="edit_auth"
            :del_auth="del_auth"
            :add_file_auth="add_file_auth"
            :to_approval_auth="to_approval_auth"
            :sel_approval_auth="sel_approval_auth"
            :ApprovalAuth="ApprovalAuth"
            :withdraw_auth="withdraw_auth"
            print_auth="打印加班申请"
            @show_edit="show_edit"
            @addTeam="addTeam"
            @search="get_over_time_index"
            @exitDialog="dialogExit"
            @frefresh="frefresh"
            @details_row="details_over_time"
        ></over-time-edit-component>
        <!-- 导出 -->
        <common-out-put-excel-component
            ref="out_excel"
            :TableName="out_excel_name"
            :HeaderArr="out_excel_heard"
            :BobyArr="out_excel_data"
        ></common-out-put-excel-component>
    </div>
</template>

<script>
import { over_time_index_request,over_time_details_request,out_excel_request} from '@/network/hrm/OverTime.js'

import OverTimeSearchBarComponent from '@/components/hrm/overtime/OverTimeSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import OverTimeEditComponent from '@/components/hrm/overtime/OverTimeEditComponent'
import CommonOutPutExcelComponent from '@/components/common/CommonOutPutExcelComponent'

export default {
    name:'OverTimeView',
    data(){
        return {
            fid: 0,
            edit_type: 0,
            loading: false,
            fdialogFormVisible: false,
            cond: {
                name: '',
                state: '',
                create_staff: '',
                start_time: '',
                end_time: '',
                page: 1,
                limit: 10,
            },
            ftotal: 0,
            ftable_data: [],
            fcol_arr: [   
                {
                    prop: 'name',
                    label: '加班单号',
                    minWidth: '120px'
                },
                {
                    prop: 'state',
                    label: '审批状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'info',
                                filter_data: '待提交'
                            }
                        } else if(d===1) {
                            return {
                                type: '',
                                filter_data: '审批中'
                            }
                        } else if(d===2) {
                            return {
                                type: 'success',
                                filter_data: '已通过'
                            }
                        } else if(d===3) {
                            return {
                                type: 'danger',
                                filter_data: '已驳回'
                            }
                        }
                    }
                },                
                {
                    prop: 'start_time',
                    label: '开始时间',
                    minWidth: '180px',
                },
                {
                    prop: 'duration',
                    label: '加班时长（小时）',
                    minWidth: '110px',
                },
                {
                    prop: 'current_examine_staff_name',
                    label: '当前审批人',
                    minWidth: '100px',
                },
                {
                    prop: 'create_staff_name',
                    label: '申请人',
                    minWidth: '100px',
                }
            ],
            over_time_details_data: {},
            edit_auth: false,
            del_auth: false,
            //补充附件
            add_file_auth: false,
            //提交
            to_approval_auth: false,
            //查看审批
            sel_approval_auth: false,
            //审批
            ApprovalAuth: false,
            //撤回审批
            withdraw_auth: false,
            out_excel_heard: [],
            out_excel_data: [],
        }
    },
    computed:{
        out_excel_name() {
            const n = new Date();
            const year = n.getFullYear();
            const month = (((n.getMonth()) + 1)+'').length === 1 ? ('0' + ((n.getMonth()) + 1)) : ((n.getMonth()) + 1);
            const date = (n.getDate()+'').length === 1 ? ('0' + n.getDate()) : n.getDate();
            const hour = (n.getHours()+'').length === 1 ? ('0' + n.getHours()) : n.getHours();
            const minute = (n.getMinutes()+'').length === 1 ? ('0' + n.getMinutes()) : n.getMinutes();
            const second = (n.getSeconds()+'').length === 1 ? ('0' + n.getSeconds()) : n.getSeconds();

            return '加班申请' + year +  month + date +  hour +  minute + second
        }
    },
    methods:{
        get_over_time_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.state = param.state ?? this.cond.state
            this.cond.create_staff = param.create_staff ?? this.cond.create_staff
            this.cond.start_time = param.start_time ?? this.cond.start_time
            this.cond.end_time = param.end_time ?? this.cond.end_time
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }
            over_time_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_over_time(id) {
            this.fid = id
            this.fdialogFormVisible = true
            over_time_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.over_time_details_data = s.result
                        //权限判断
                        this.is_auth(s.result)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
        frefresh() {
            this.details_over_time(this.fid)
            this.get_over_time_index()
        },
        is_auth(res) {
            this.edit_auth = false
            this.del_auth = false
            this.add_file_auth = false
            this.to_approval_auth = false
            this.sel_approval_auth = false
            this.ApprovalAuth = false
            this.withdraw_auth = false

            if(res.state === 0) {
                //判断创建人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.to_approval_auth = this.$_has('提交加班申请')
                    this.edit_auth = this.$_has('修改加班申请')
                    this.del_auth = this.$_has('删除加班申请')
                }
            } else if(res.state === 1) {
                 //判断创建人或申请人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.withdraw_auth = this.$_has('撤回加班申请')
                    this.add_file_auth = this.$_has('补充加班申请附件')
                }
                //判断当前审批人是否为自己
                if(res.current_examine_staff_id === this.$store.state.user.id) {
                    this.ApprovalAuth = this.$_has('审批加班申请')
                }
                this.sel_approval_auth = this.$_has('查看加班申请审批记录')
            } else if(res.state === 2) {
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.add_file_auth = this.$_has('补充加班申请附件')
                }
                this.sel_approval_auth = this.$_has('查看加班申请审批记录')
            } else if(res.state === 3) {
                //判断创建人或申请人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.to_approval_auth = this.$_has('提交加班申请')
                    this.edit_auth = this.$_has('修改加班申请')
                    this.del_auth = this.$_has('删除加班申请')
                }
                this.sel_approval_auth = this.$_has('查看加班申请审批记录')
            }
        },
        outExcel() {
            this.out_excel_heard = [
                {label: '单号',prop: 'name'},
                {label: '标题',prop: 'title'},
                {label: '状态',prop: 'status_name'},
                {label: '时长(小时)',prop: 'duration'},
                {label: '开始时间',prop: 'start_time'},
                {label: '结束时间',prop: 'end_time'},
                {label: '申请人',prop: 'create_staff_name'}
            ]

            out_excel_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.out_excel_data = s.result
                        this.$refs['out_excel'].outExcel()
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        }
    },
    filters:{},

    props:{},
    created(){
      this.get_over_time_index()
    },
    destoryed(){},
    mounted(){},
    updated(){},
    components:{
        OverTimeSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        OverTimeEditComponent,
        CommonOutPutExcelComponent
    },
    watch:{}
}
</script>

<style lang='less'></style>
